<template>
    <section class="clientResponse">
        <div v-if="clientResponse.length > 0">
          <div  v-for="(arr,key) in clientResponse" :key="key">
              <h2>{{arr[0]}}</h2>
              <p>
                  {{arr[1]}}
                  <strong>{{arr[2]}}</strong>
              </p>
          </div>
        </div>

        <div v-if="Object.keys(responseLog).length > 0">
          <div  v-for="(value, client) in responseLog" :key="client">
            <h2>{{client}}</h2>
            <div v-for="(obj, i) in value" :key="i">
              <p> <strong>SENT</strong> {{obj.req}} </p>
              <p> <strong>RECEIVED</strong> {{obj.res}} </p>
            </div>
          </div>
        </div>

        <pre>
          {{responseLog}}
        </pre>
    </section>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  name: "clientResponse",
  computed: {
    ...mapState(["clientResponse", "responseLog"])
  },
  methods: {
    ...mapMutations(["updateClientResponse", "updateResponseLog"])
  },
  sockets: {
    resCommandSent(data) {
      console.log(data)
      let arrClientAdmin = Object.keys(data);
      let arrOfResponses = [];
      arrClientAdmin.forEach(tuple => {
        let client = tuple.split(",")[0];
        let command = Object.keys(data[tuple])[0];
        let response = data[tuple][command];
        arrOfResponses.push([client, command, response]);
      });
      this.updateClientResponse(arrOfResponses);
    },
    resResponseLog(data) {
      console.log("resResponseLog", data);
      this.updateResponseLog(data);
    }
  }
};
</script>
